// extracted by mini-css-extract-plugin
export default {"header":"modal_header__Brzru","footer":"modal_footer__SHd3B","body":"modal_body__s0PUS"};